<template>
  <el-form :inline="true" :model="formApartment">
    <el-drawer
     :visible.sync="drawer"
     direction="rtl"
     :with-header="false"
     >
   <el-alert
    :title="$t('deviceApartmentDetail.hint')"
    type="info"
    :description="$t('deviceApartmentDetail.roomListQurey')"
    show-icon
    :closable="false"
    >
    </el-alert>
    <el-form :inline="true" class="demo-ruleForm" style="margin-top:10px">
      <el-form-item :label="$t('deviceApartmentDetail.roomName')" label-width="100px" style="display:flex;justify-content:center;">
        <el-input v-model="selectForm.roomName" autocomplete="off" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('deviceApartmentDetail.checkInStatus')" label-width="100px" style="display:flex;justify-content:center;">
        <el-select v-model="selectForm.checkIn" :placeholder="$t('deviceApartmentDetail.pleaseChoose')">
        <el-option key="" :label="$t('deviceApartmentDetail.all')" value=""></el-option>
        <el-option key="0" :label="$t('deviceApartmentDetail.noshow')" value=0></el-option>
        <el-option key="3" :label="$t('deviceApartmentDetail.checkIn')" value=3></el-option>
      </el-select>
      </el-form-item>
       <el-form-item :label="$t('deviceApartmentDetail.deviceStatus')" label-width="100px" style="display:flex;justify-content:center;">
        <el-select v-model="selectForm.isBind" :placeholder="$t('deviceApartmentDetail.pleaseChoose')">
        <el-option key="" :label="$t('deviceApartmentDetail.all')" value=""></el-option>
        <el-option key="0" :label="$t('deviceApartmentDetail.noBind')" value=0></el-option>
        <el-option key="1" :label="$t('deviceApartmentDetail.alreadyBind')" value=1></el-option>
      </el-select>
      </el-form-item>
      <el-form-item style="display:flex;justify-content:center;">
      <el-button @click="drawer=false">{{$t('deviceApartmentDetail.cancel')}}</el-button>
      <el-button type="primary" @click="onSelect">{{$t('deviceApartmentDetail.confirm')}}</el-button>
      </el-form-item>
    </el-form>
    </el-drawer>
    
    <el-card class="box-card" shadow="hover">
      <div slot="header" style="background-color:#EBEEF5">
        <span v-show="!formApartment.isSpread">
          <el-button
            icon="el-icon-caret-right"
            type="text"
            @click="spreadMore"
            style="font-size:20px;color:#606266;font-weight: bold;"
          >
            {{ formApartment.apartmentName }}
            <font style="font-size:14px;">{{$t('deviceApartmentDetail.manageText')}}</font>
          </el-button>
          
        </span>
        <span v-show="formApartment.isSpread">
          <el-button
            icon="el-icon-caret-bottom"
            type="text"
            @click="spreadMore"
            style="font-size:20px;color:#606266;font-weight: bold;"
            >{{ formApartment.apartmentName }}</el-button
          >
        </span>
        <el-button type="primary" icon="el-icon-folder-opened" :title="$t('deviceApartmentDetail.openSreach')" size="small" @click="openSelect" round style="float:right;margin-top:7px;margin-right:5px">{{$t('deviceApartmentDetail.openSreach')}}</el-button>
      </div>
      <div v-show="formApartment.isSpread">
        <el-form-item :label="$t('deviceApartmentDetail.apartmentName')">
          <el-input
            v-model="formApartment.apartmentName"
            :disabled="formApartment.isDisabled"
            :placeholder="$t('deviceApartmentDetail.apartmentName')"
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('deviceApartmentDetail.area')">
          <el-select
            v-model="formApartment.province"
            :disabled="formApartment.isDisabled"
            @change="getProvinceValue"
            :placeholder="$t('deviceApartmentDetail.province')"
            style="width:200px"
          >
            <el-option
              v-for="item in this.$store.state.provinceList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="formApartment.city"
            :disabled="formApartment.isDisabled"
            @change="getCityValue"
            :placeholder="$t('deviceApartmentDetail.city')"
            style="width:200px"
          >
            <el-option
              v-for="item in this.$store.state.cityList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="formApartment.area"
            :disabled="formApartment.isDisabled"
            :placeholder="$t('deviceApartmentDetail.area-county')"
          >
            <el-option
              v-for="item in this.$store.state.areaList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('deviceApartmentDetail.apartmentType')">
          <el-select
            v-model="formApartment.apartmentType"
            :disabled="formApartment.isDisabled"
            :placeholder="$t('deviceApartmentDetail.apartmentType')"
            style="width:200px;"
          >
            <el-option key="0" :label="$t('deviceApartmentDetail.fss')" value="0"></el-option>
            <el-option key="1" :label="$t('deviceApartmentDetail.jzs')" value="1"></el-option>
            <el-option key="2" :label="$t('deviceApartmentDetail.jds')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('deviceApartmentDetail.apartmentAddress')">
          <el-input
            v-model="formApartment.apartmentName"
            :disabled="formApartment.isDisabled"
            :placeholder="$t('deviceApartmentDetail.apartmentAddress')"
            style="width:480px"
          ></el-input>
        </el-form-item>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top:3px">
      <el-tabs
        v-model="activeTab"
        type="border-card"
        @tab-remove="removeTab"
        @tab-click="tabClickInfo"
      >
        <el-tab-pane
          v-for="(item, index) in tabsItem"
          :key="item.name"
          :label="item.title"
          :name="item.name"
          :closable="item.closable"
          :ref="item.ref"
        >
          <component
            :is="item.content"
            v-bind:infoData="idata"
            v-bind:roomData="roomData"
            v-bind:tabIndex="tabIndex"
            v-bind:sonTabsItem="sonTabsItem"
            v-if="
              item.id == 1 ||
                item.id == roomData.roomId ||
                item.id == roomData.deviceId ||
                item.id == roomData.floorId
            "
          ></component>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </el-form>
</template> 
<script>
import Vue from "vue";
import apartmentRoomList from "./apartmentRoomList.vue";
import apartmentRoomDetail from "./apartmentRoomDetail.vue";
import commomArea from "./commomArea.vue";
import deviceDetail from "./deviceDetail.vue";
import gatewayDetail from "./gatewayDetail.vue";
export default {
  name: "deviceApartmentDetail", //公寓详情
  props: ["idata", "tabs", "sonTabsItem"],
  data() {
    return {
      drawer: false,
      isDelete:false,
      formApartment: {
        apartmentName: this.idata.apartmentName,
        province: this.idata.province,
        city: this.idata.city,
        area: this.idata.area,
        apartmentType: this.idata.apartmentType + "",
        apartmentAddress: this.idata.apartmentAddress,
        isDisabled: true, //公寓信息是否编辑状态
        isSpread: false
      },
      activeTab: "1", //默认显示的tab
      roomData: "",
      tabIndex: 1, //tab目前显示数
      tabsItem: [
        {
          title: this.$t('deviceApartmentDetail.roomList'),
          id: "1",
          name: "1",
          closable: false,
          ref: "",
          content: apartmentRoomList
        }
      ],
      tabsPath: [
        {
          name: "1",
          path: "/apartmentRoomList"
        }
      ],
      selectForm:{
        roomName:"",
        checkIn:"",
        isBind:""
      },
    };
  },

  mounted() {
    /*
     * 监听页面刷新事件
     * 页面刷新前 需要保存当前打开的tabs的位置，刷新后按刷新前的顺序展示
     * 使用js的sessionStorage保存刷新页面前的数据
     * */
    // window.addEventListener("beforeunload", e => {
    //   sessionStorage.setItem(
    //     "tabsItem",
    //     window.JSON.stringify({
    //       currTabsItem: this.tabsItem.filter(item => item.name !== "1"),
    //       currTabsPath: this.tabsPath.filter(item => item.name !== "1"),
    //       currActiveTabs: this.activeTab,
    //       currIndex: this.tabIndex
    //     })
    //   );
    // });
  },

  created() {
    Vue.prototype.$mainInfo = this;
    var sonTabsItem = this.sonTabsItem;
    for (var str in sonTabsItem) {
      if (sonTabsItem[str].apartmentId == this.idata.apartmentId) {
        this.tabsItem = sonTabsItem[str].tabsItem;
        this.tabIndex = this.tabsItem.length;
      }
    }
    // var tab=this.tabs.filter(tab => tab.id == this.idata.apartmentId);
    // this.tabsItem=tab[0].tabsItemSon;
    /*
     * 使用js的sessionStorage读取刷新前的数据，并按刷新前的tabs顺序重新生成tabs
     * */
    // const sessionTabs = JSON.parse(sessionStorage.getItem("tabsItem"));
    // if (
    //   sessionTabs != null &&
    //   sessionTabs.currTabsItem.length != 0 &&
    //   sessionTabs.currTabsPath.length != 0
    // ) {
    //   for (let i = 0; i < sessionTabs.currTabsItem.length; i++) {
    //     this.tabsItem.push({
    //       title: sessionTabs.currTabsItem[i].title,
    //       name: sessionTabs.currTabsItem[i].name,
    //       closable: true,
    //       ref: sessionTabs.currTabsItem[i].ref,
    //       content: sessionTabs.currTabsItem[i].content
    //     });
    //   }
    //   for (let j = 0; j < sessionTabs.currTabsPath.length; j++) {
    //     this.tabsPath.push({
    //       name: sessionTabs.currTabsPath[j].name,
    //       path: sessionTabs.currTabsPath[j].path
    //     });
    //   }
    //   this.activeTab = sessionTabs.currActiveTabs;
    //   this.tabIndex = sessionTabs.currIndex;
    //   //避免强制修改url 出现浏览器的url输入框的路径和当前tabs选中的路由路径不匹配
    //   const activePath = this.tabsPath.filter(
    //     item => item.name == this.activeTab
    //   );
    //   this.$router.push({
    //     path: activePath[0].path
    //   });
    // }
  },
  methods: {
    onSelect(){
      this.drawer=false;
      this.$store.commit("getApartmentDetail", {
         apartmentId: this.idata.apartmentId,
         roomName:this.selectForm.roomName,
         isBindDevice:this.selectForm.isBind,
         status:this.selectForm.checkIn

      }); //加载公寓楼栋
    },
    openSelect(){
        this.drawer=true;
    },
    addGatewayDetail(data) {
      var oldActiveIndex = "";
      var exist = false;
      var tabData = this.tabsItem;
      this.roomData = data;
      for (var str in tabData) {
        if (data.deviceId === tabData[str].id) {
          oldActiveIndex = tabData[str].name;
          exist = true;
          break;
        }
      }
      if (exist === true) {
        this.activeTab = oldActiveIndex;
        return;
      }
      //获得路由元数据的name和组件名
      const thisName = data.deviceName;
      const thisComp = "gatewayDetail";
      //对tabs的当前激活下标和tabs数量进行自加
      var newActiveIndex = ++this.tabIndex + "";
      var obj={
        title: thisName,
        id: data.deviceId,
        name: String(newActiveIndex),
        closable: true,
        ref: data,
        content: thisComp,
        type: 2, //2网关
        index: newActiveIndex
      }
      this.tabsItem.push(obj);
      //传值也加tab
      var item = this.sonTabsItem;
      for (var str in item) {
        if (item[str].apartmentId == this.idata.apartmentId) {
          if(this.isDelete){
             item[str].tabsItem.push(obj);
          }
        }
      }
      this.activeTab = newActiveIndex;
    },

    addDevcieDetail(data) {
      var oldActiveIndex = "";
      var exist = false;
      var tabData = this.tabsItem;
      this.roomData = data;
      for (var str in tabData) {
        if (data.deviceId === tabData[str].id) {
          oldActiveIndex = tabData[str].name;
          exist = true;
          break;
        }
      }
      if (exist === true) {
        this.activeTab = oldActiveIndex;
        return;
      }

      //获得路由元数据的name和组件名
      const thisName = data.deviceName;
      const thisComp = "deviceDetail";
      //对tabs的当前激活下标和tabs数量进行自加
      var newActiveIndex = ++this.tabIndex + "";
      var obj={
        title: thisName,
        id: data.deviceId,
        name: String(newActiveIndex),
        closable: true,
        ref: data,
        content: thisComp,
        type: 1, //1门锁
        index: newActiveIndex
      }
      this.tabsItem.push(obj);
      //传值也加tab
      var item =this.sonTabsItem;
      for (var str in item) {
        if (item[str].apartmentId == this.idata.apartmentId) {
          if(this.isDelete){
             item[str].tabsItem.push(obj);
          }
        }
      }
      this.activeTab = newActiveIndex;
    },

    addCommomArea(data) {
      var oldActiveIndex = "";
      var exist = false;
      var tabData = this.tabsItem;
      this.roomData = data;
      for (var str in tabData) {
        if (data.floorId === tabData[str].id) {
          oldActiveIndex = tabData[str].name;
          exist = true;
          break;
        }
      }

      if (exist === true) {
        this.activeTab = oldActiveIndex;
        return;
      }
      //获得路由元数据的name和组件名
      const thisName =
        this.formApartment.apartmentType == 0
          ? this.$t('deviceApartmentDetail.publicArea')
          : data.floorName + this.$t('deviceApartmentDetail.publicArea');
      const thisComp = "commomArea";
      //对tabs的当前激活下标和tabs数量进行自加
      var newActiveIndex = ++this.tabIndex + "";
      var obj={
        title: thisName,
        id: data.floorId,
        name: String(newActiveIndex),
        closable: true,
        ref: data,
        content: thisComp,
        type: 0, //1公共区域
        index: newActiveIndex
      }
      this.tabsItem.push(obj);
      var item =this.sonTabsItem;
      for (var str in item) {
        if (item[str].apartmentId == this.idata.apartmentId) {
          if(this.isDelete){
             item[str].tabsItem.push(obj);
          }
        }
      }
      this.activeTab = newActiveIndex;
    },

    addManageRoom(data) {
      var oldActiveIndex = "";
      var exist = false;
      var tabData = this.tabsItem;
      this.roomData = data;
      for (var str in tabData) {
        if (data.roomId === tabData[str].id) {
          oldActiveIndex = tabData[str].name;
          exist = true;
          break;
        }
      }
      if (exist == true) {
        this.activeTab = oldActiveIndex;
        return;
      }
      //获得路由元数据的name和组件名
      const thisName = data.roomName;
      const thisComp = "apartmentRoomDetail";
      //对tabs的当前激活下标和tabs数量进行自加
      var newActiveIndex = ++this.tabIndex + "";
      var obj={
        title: thisName,
        id: data.roomId,
        name: String(newActiveIndex),
        closable: true,
        ref: data,
        content: thisComp,
        type: 3, //房间管理
        index: newActiveIndex
      }
      this.tabsItem.push(obj);
      var item = this.sonTabsItem;
      for (var str in item) {
        if (item[str].apartmentId == this.idata.apartmentId) {
          if(this.isDelete){
             item[str].tabsItem.push(obj);
          }
        }
      }
      this.activeTab = newActiveIndex;
    },

    getCityValue(val) {
      this.$store.commit("area", { cityCode: val }); //加载区（县）
      this.formApartment.area = "";
    },
    getProvinceValue(val) {
      this.$store.commit("city", { provinceCode: val }); //加载城市
      this.formApartment.city = "";
      this.formApartment.area = "";
    },

    removeTab(targetName) {
      //删除Tab
      var tabs = this.tabsItem; //当前显示的tab数组
      this.isDelete=true;
      var activeName = this.activeTab; //点前活跃的tab
      //如果当前tab正活跃 被删除时执行
      if (activeName == targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name == targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
              this.tabClickInfo(nextTab);
            }
          }
        });
      }
      var strItem=[];
      this.activeTab = activeName;
      this.tabsItem = tabs.filter(tab => tab.name != targetName);
      var sonTabsItem = this.sonTabsItem;
      for (var str in sonTabsItem) {
        if (sonTabsItem[str].apartmentId == this.idata.apartmentId) {
          var temp = sonTabsItem[str].tabsItem;
          strItem = [];
          for (var s in temp) {
            if (temp[s].name != targetName) {
              strItem.push(temp[s]);
            }
          }
          sonTabsItem[str].tabsItem = strItem;
        }
      }
      // console.log(this.getMaxTabs(strItem));
      this.tabIndex=this.getMaxTabs(strItem);//删除后返回当前tabs最大计数的tab
      // this.$emit("closeMain", sonTabsItem); //修改父组件的值
      //在tabsPath中删除当前被删除tab的path
      this.tabsPath = this.tabsPath.filter(item => item.name != targetName);
      
    },
    tabClickInfo(thisTab, event) {
      /*
       * thisTab:当前选中的tabs的实例
       * 通过当前选中tabs的实例获得当前实例的path 重新定位路由
       * */
      let val = this.tabsItem.filter(item => thisTab.name == item.name); //因为name不同必须用ID比较
      if (val[0].name == "1") {
        this.roomData = "";
      } else {
        this.roomData = val[0].ref;
        if(!this.isDelete){//判断不是删除才赋值tabIndex
          this.tabIndex=val[0].name;
          this.isDelete=false//初始化删除状态
        }
        
        // this.tabIndex = thisTab.name;
        this.$store.commit("getApartmentDetail", {
            apartmentId: this.idata.apartmentId
        }); //加载公寓楼栋
      }
    },
    spreadMore(val) {
      if (this.formApartment.isSpread == true) {
        this.formApartment.isSpread = false;
      } else {
        this.formApartment.isSpread = true;
      }
    },
    getMaxTabs(tabs){//计算当前tabs中最大name
      return Math.max.apply(Math, tabs.map(function(o) {return o.name}));
    }
  },
  components: {
    apartmentRoomList,
    apartmentRoomDetail,
    commomArea,
    deviceDetail,
    gatewayDetail
  }
};
</script>  


// WEBPACK FOOTER //
// src/components/device/deviceApartmentDetail.vue